import React, { useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./styles.scss";

const ButtonManagerElement = ({
  onClick,
  icon,
  label,
  isFirstElement,
  isLastElement,
  tooltipText,
}) => {
  const renderButtonElementContent = () => {
    return (
      <div
        className={buttonStyle}
        onClick={() => {
          try {
            onClick();
          } catch (error) {
            console.error("ButtonManagerElement ", label," error:", error)
          }
        }}
      >
        <img src={icon} />
        <h4 className="font-size rojo noselect">{label}</h4>
      </div>
    );
  };

  var buttonStyle = "ButtonManagerItem";

  if (isFirstElement) {
    buttonStyle = buttonStyle + " ButtonManagerItemFirstElement";
  }

  if (isLastElement) {
    buttonStyle = buttonStyle + " ButtonManagerItemLastElement";
  }

  if (tooltipText) {
    return (
      <OverlayTrigger
        placement={"top"}
        overlay={
          <Tooltip
            style={{
              marginBottom: "0.5%",
            }}
          >
            {tooltipText}
          </Tooltip>
        }
      >
        {renderButtonElementContent()}
      </OverlayTrigger>
    );
  }else{
    return renderButtonElementContent();
  }
};

export default ButtonManagerElement;
